module.exports = __webpack_public_path__ + "img/devices_white.d06a5fd5.svg";